export var Section;
(function (Section) {
    Section["Screener"] = "mt-screener";
    Section["MessageAnalysis"] = "mt-message-analysis";
    Section["MaxDiffExercise"] = "mt-max-diff";
    Section["OrderingExercise"] = "mt-ordering";
    Section["Demographics"] = "mt-demographics";
})(Section || (Section = {}));
export var Question;
(function (Question) {
    Question["PrimarySpecialty"] = "mt-primary-specialty";
    Question["Qualification"] = "mt-qualification";
    Question["Certified"] = "mt-certified";
    Question["PracticeYears"] = "mt-practice-years";
    Question["ProfessionalActivities"] = "mt-professional-activities";
    Question["PatientConditions"] = "mt-patient-conditions";
    Question["TherapyWillingness"] = "mt-therapy-willingness";
    Question["EmployerCheck"] = "mt-employer-check";
    Question["MarketResearchCheck"] = "mt-market-research";
    Question["MessageDimensionOne"] = "mt-dimension-one";
    Question["MessageDimensionTwo"] = "mt-dimension-two";
    Question["MaxDiff"] = "mt-max-diff";
    Question["MaxDiffMost"] = "mt-max-diff-most";
    Question["MaxDiffSecondMost"] = "mt-max-diff-2nd-most";
    Question["MaxDiffLeast"] = "mt-max-diff-least";
    Question["MaxDiffSecondLeast"] = "mt-max-diff-2nd-least";
    Question["OrderingExercise"] = "mt-ordering-exercise";
    Question["Attitudinals"] = "mt-attitudinals";
    Question["PracticePhysicians"] = "mt-practice-physicians";
    Question["PracticeSetting"] = "mt-practice-setting";
    Question["PracticeEmployees"] = "mt-practice-employees";
    Question["AdministrativeStaff"] = "mt-admin-staff";
    Question["Gender"] = "mt-gender";
    Question["Age"] = "mt-age";
})(Question || (Question = {}));
export var Message;
(function (Message) {
    Message["TPPIntro"] = "mt-tpp";
    Message["DemoIntro"] = "mt-demo-intro";
})(Message || (Message = {}));
export var Logic;
(function (Logic) {
    Logic["PrimarySpecialty"] = "mt.logic.primary-specialty";
})(Logic || (Logic = {}));
